// translations/pages/team/de.js
// Texts of the team overview and of the navigation inside a profile. The
// profiles themselves come from src/profile (one folder per member).
export const teamPageDE = {
  hero: {
    title: 'Team',
    intro: 'Adrian Eisenmeier und Nikolai Genov haben die pAIoneer Labs GmbH gegründet und führen sie als Geschäftsführer.',
    members: 'Adrian Eisenmeier ist Diplom-Physiker und entwickelt Systeme dort, wo KI, Softwarearchitektur, Datenschutz und Sicherheit zusammenlaufen. Nikolai Genov ist promovierter Bioinformatiker und technischer Lead für KI-gestützte Softwareentwicklung und Analytics in regulierten Umgebungen aus Healthcare, Life Sciences und Finance. Alina Tselinina ist Softwareentwicklerin und Data Engineer mit einem Master in Finanz- und Versicherungsmathematik und entwickelt Anwendungen, REST-APIs und Datenpipelines in Python und R.'
  },
  card: {
    cta: 'Profil ansehen'
  },
  profile: {
    overview: 'Team',
    membersLabel: 'Teammitglieder'
  }
};
